import angular from "angular";

angular
    .module('organizationsControl.transactionInfo', [])
    .component('transactionInfo', {
        controller: [controller],
        template: require('./transaction-info.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.t = $ctrl.resolve.transaction;
    };
}

export default 'organizationsControl.transactionInfo';


// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/transaction-info/transaction-info.js